import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Button from "./button"

export default function CityCard(story) {
  const data = story.story
  const hero = data.frontmatter.hero
  return (
    <div key={story.id} className="max-w-6xl mx-auto m-0">
      <div className="relative aspect-square md:aspect-video">
        <GatsbyImage
          image={getImage(hero)}
          alt={data.frontmatter.hero_alt}
          imgClassName="object-cover"
          className="w-full h-full"
        />
        <div className="absolute inset-0 bg-copper/50 mix-blend-multiply"></div>
        <div className="absolute inset-0 flex flex-col justify-center items-center">
          <div className="border-0 lg:border border-white py-1 px-2 mb-2">
            <h2 className="uppercase text-base text-sm font-bold text-white text-center">
              {data.frontmatter.tag}
            </h2>
          </div>
          <h3 className="font-dharma text-white text-5xl lg:text-7xl mb-4">
            {data.frontmatter.city}
          </h3>
          <Button
            link={data.frontmatter.slug}
            text="Learn More"
            color="gray"
            hover="gray"
            type="small"
          />
        </div>
      </div>
    </div>
  )
}
